// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"7041ed03","453":"73a353d6","455":"f4163110","977":"86d65106"}[chunkId] + ".chunk.js";
};